import { SpineGameObject } from "@esotericsoftware/spine-phaser";
import Phaser from "phaser";

export default class Pick {
    private pickSpine: SpineGameObject
    private pickText: Phaser.GameObjects.Text
    private isPicked: boolean = false;
    private pickContainer: Phaser.GameObjects.Container;
    private debugGraphics: Phaser.GameObjects.Graphics;

    constructor(scene: any, pickContainer: Phaser.GameObjects.Container, pickSpine: SpineGameObject, pickText: Phaser.GameObjects.Text, debugGraphics: Phaser.GameObjects.Graphics) {
        this.pickSpine = pickSpine;
        this.pickText = pickText;
        this.debugGraphics = debugGraphics;
        this.pickContainer = pickContainer;
        this.pickContainer.add(this.pickSpine);
        this.pickContainer.add(this.pickText);
        this.pickContainer.add(this.debugGraphics);
    }

    public getPickSpine(): SpineGameObject {
        return this.pickSpine;
    }

    public getPickText(): Phaser.GameObjects.Text {
        return this.pickText;
    }

    public getPickContainer(): Phaser.GameObjects.Container {
        return this.pickContainer;
    }

    public getIsPicked(): boolean {
        return this.isPicked;
    }

    public setIsPicked(isPicked: boolean): void {
        this.isPicked = isPicked;
    }

    public getDebugGraphics(): Phaser.GameObjects.Graphics {
        return this.debugGraphics;
    }

    public setDebugGraphics(debugGraphics: Phaser.GameObjects.Graphics): void {
        this.debugGraphics = debugGraphics;
    }
}